import { render, staticRenderFns } from "./Dresscode.vue?vue&type=template&id=06f1fc6a&scoped=true&"
import script from "./Dresscode.vue?vue&type=script&lang=js&"
export * from "./Dresscode.vue?vue&type=script&lang=js&"
import style0 from "./Dresscode.vue?vue&type=style&index=0&id=06f1fc6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f1fc6a",
  null
  
)

export default component.exports